export const dashboard = <i className="fa-solid fa-chart-line"></i>;
export const transactions = <i className="fa-solid fa-credit-card"></i>;
export const categories = <i className="fa-solid fa-tags"></i>;
export const accounts = <i className="fa-solid fa-wallet"></i>;
export const settings = <i className="fa-solid fa-cog"></i>;
export const logout = <i className="fa-solid fa-sign-out"></i>;
export const trend = <i className="fa-solid fa-money-bill-trend-up"></i>;
export const expenses = <i className="fa-solid fa-money-bill-transfer"></i>;
export const money = <i className="fa-solid fa-money-bill"></i>;
export const stocks = <i className="fa-solid fa-arrow-trend-up"></i>;
export const bitcoin = <i className="fa-brands fa-bitcoin"></i>;
export const piggy = <i className="fa-solid fa-piggy-bank"></i>;
export const yt = <i className="fa-brands fa-youtube"></i>;
export const card = <i className="fa-brands fa-cc-visa"></i>;
export const users = <i className="fa-solid fa-users-between-lines"></i>;
export const dollar = <i className="fa-solid fa-dollar-sign"></i>;
export const calendar = <i className="fa-solid fa-calendar"></i>;
export const comment = <i className="fa-solid fa-comment"></i>;
export const plus = <i className="fa-solid fa-plus"></i>;
export const trash = <i className="fa-solid fa-trash"></i>;
export const signout = <i className="fa-solid fa-right-from-bracket"></i>;
export const food = <i className="fa-solid fa-bowl-food"></i>;

//incomes
export const cheese = <i className="fa-solid fa-cheese"></i>;
export const business = <i className="fa-solid fa-business-time"></i>;
export const bonus = <i className="fa-solid fa-plus"></i>;
// expenses
export const home = <i className="fa-solid fa-house"></i>;
export const outside = <i className="fa-solid fa-beer-mug-empty"></i>;
export const cart = <i className="fa-solid fa-cart-shopping"></i>;
export const bills = <i className="fa-solid fa-money-bills"></i>;
export const car = <i className="fa-solid fa-car"></i>;
